import merge from 'lodash/merge';
import uniq from 'lodash/uniq';
import { normalize } from 'normalizr';

import * as actions from 'actions/events';
import * as dateRangeFilterActions from 'actions/dateRangeFilter';

import * as schemas from './schema';

export const getDefaultState = () => ({
  error: false,
  loading: false,
  isLoadingMore: false,
  isLoadingCount: false,
  loaded: false,
  entities: {},
  result: [],
  links: {},
  showDataAccessAlert: false,
  dataAccessFromDate: undefined,
  dataRequestId: null,
  // Used for the new Events table
  total: 0,
});

function getInitialStateForRequestId(state, dataRequestId) {
  if (state.dataRequestId === dataRequestId) {
    return state;
  }
  const defaultState = getDefaultState();
  return {
    ...state,
    dataRequestId,
    result: defaultState.result,
    links: defaultState.links,
    total: defaultState.total,
  };
}

export default function events(state = getDefaultState(), action) {
  switch (action.type) {
    case actions.SEARCH_START: {
      return {
        ...getInitialStateForRequestId(state, action.payload.dataRequestId),
        loading: true,
        error: false,
      };
    }
    case actions.LOAD_MORE_START:
      return {
        ...state,
        isLoadingMore: true,
        error: false,
      };
    case actions.PAGE_START:
      return {
        ...state,
        loading: true,
        isLoadingMore: true,
        error: false,
      };
    case actions.COUNT_START: {
      return {
        ...getInitialStateForRequestId(state, action.payload.dataRequestId),
        isLoadingCount: true,
        error: false,
      };
    }
    case actions.LOAD_MORE_SUCCESS:
    case actions.PAGE_SUCCESS: {
      const normalizedLoadMore = normalize(
        action.payload.data,
        schemas.arrayOfEvents,
      );
      const { links } = action.payload;

      return {
        ...state,
        entities: merge({}, state.entities, normalizedLoadMore.entities),
        result: uniq([...state.result, ...normalizedLoadMore.result]),
        links,
        loading: false,
        isLoadingMore: false,
        error: false,
      };
    }
    case actions.COUNT_SUCCESS: {
      const { total, dataRequestId } = action.payload;
      if (state.dataRequestId !== dataRequestId) {
        // Old request came in after a new request started, ignore the results.
        return state;
      }
      return {
        ...state,
        total,
        isLoadingCount: false,
        error: false,
      };
    }
    case actions.SEARCH_SUCCESS: {
      const { links, dataRequestId } = action.payload;
      if (state.dataRequestId !== dataRequestId) {
        // Old request came in after a new request started, ignore the results.
        return state;
      }
      const normalizedLoad = normalize(
        action.payload.data,
        schemas.arrayOfEvents,
      );

      return {
        ...state,
        ...normalizedLoad,
        links,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case actions.SEARCH_FAIL:
    case actions.PAGE_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case actions.LOAD_MORE_FAIL:
      return {
        ...state,
        isLoadingMore: false,
        error: true,
      };
    case actions.COUNT_FAIL:
      return {
        ...state,
        isLoadingCount: false,
        error: true,
      };
    case actions.GET_BY_ID_START:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case actions.GET_BY_ID_SUCCESS:
      return {
        ...state,
        ...normalize(action.payload, schemas.events),
        loading: false,
        error: false,
      };
    case actions.GET_BY_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case dateRangeFilterActions.DATE_RANGE_FILTER_DATA_ACCESS_EXCEPTION: {
      const formattedDataAccessFromDate = action.payload
        ? action.payload.format('LL')
        : undefined;
      return {
        ...state,
        dataAccessFromDate: formattedDataAccessFromDate,
        showDataAccessAlert: true,
      };
    }
    case dateRangeFilterActions.INITIALIZE_DATE_RANGE_FILTER_DATA_ACCESS_EXCEPTION: {
      return {
        ...state,
        showDataAccessAlert: false,
        dataAccessFromDate: undefined,
      };
    }
    case actions.CLEAR: {
      return {
        ...getDefaultState(),
      };
    }
    default:
      return state;
  }
}
